import { Accordion, Button, Card, Carousel, Col, Collapse, Container, Form, Row } from 'react-bootstrap';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { CiFilter } from 'react-icons/ci';
import { FaAppleAlt, FaChevronRight, FaCouch, FaFilter, FaLaptop, FaMinus, FaPlus, FaTshirt } from 'react-icons/fa';
import { useProducts } from '../products/hooks/useProducts';
import { useEffect, useState } from 'react';
import { DetailProductProvider } from './DetailsProductContext';
import CategoriesList from '../../shared/components/CategoriesList';
import { useLocation, useNavigate } from 'react-router-dom';
import FilterCard from '../products/components/FilterCard';
import { MdOutlineAddShoppingCart } from 'react-icons/md';
import Topbar from '../../shared/components/Topbar';
import NavbarComp from '../../shared/components/Navbar';
import { useCarts } from '../products/hooks/useCart';
import NavbarBackComp from '../../shared/components/NavbarBack';
import { BiPlusCircle } from 'react-icons/bi';
import Swal from 'sweetalert2';
import Footer from '../../shared/components/Footer';
import { RxSlash } from 'react-icons/rx';

const DetailProductsPage = () => {

    const {
        addProductCart,
        editProductCart,
        error,
        loading,
        cart,
        fetchProductCartsById
    } = useCarts();

    const { fetchProducts, products, onAddToCart, onAddToFav } = useProducts();

    const [fontSizes, setFontSizes] = useState({
        spanSize: 12,
        titleSize: 17,
    });

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 576) {
                // xs
                setFontSizes({ spanSize: 8, titleSize: 8 });
            } else if (width < 768) {
                // sm
                setFontSizes({ spanSize: 8, titleSize: 10 });
            } else {
                // md and up
                setFontSizes({ spanSize: 13, titleSize: 17 });
            }
        };

        handleResize(); // Initial call
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navigate = useNavigate();

    const [carts, setCarts] = useState()

    const location = useLocation();
    const product = location.state?.row;

    const [quantity, setQuantity] = useState(1); // Default quantity to 1
    const [order, setOrder] = useState();

    // Handle quantity change
    const handleQuantityChange = (event) => {
        const value = Math.max(1, event.target.value); // Ensure quantity is at least 1
        setQuantity(value);
    };

    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        category: "",
        price: "",
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const handleOnAddToCart = async (data) => {
        // Show loading Swal
        Swal.fire({
            title: 'Adding to Cart...',
            text: 'Please wait while we add your item to the cart.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const rowDataAddCart = {
                qty: quantity,
                product: data
            };

            await addProductCart(rowDataAddCart);

            Swal.close();
            navigate('/cart'); // Redirect to cart
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to add item to cart. Please try again.',
                icon: 'error'
            });
        }
    }

    const handleBack = () => {
        navigate(-1)
    }

    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <Container fluid style={{
                backgroundColor: '#f0f0f0',// Make sure the path is correct
                backgroundPosition: 'top right', // Position the image at the top-right corner
                backgroundSize: 'auto', // Adjust the size of the background image
                height: 'auto', // Make the container take full height (optional)
            }}>
                <Container className='md justify-content-center'>
                    <NavbarBackComp
                        expand="lg"
                        sticky="top"
                        handleBack={handleBack}
                    />
                    <DetailProductProvider>

                        <Container className='pt-3'>

                            <span style={{
                                fontSize: fontSizes.spanSize,
                                color: 'gray'
                            }}>
                                RS YARSI
                            </span>

                            <p className='h6' style={{
                                fontSize: fontSizes.titleSize,
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                                padding: '0.1rem',
                                paddingBottom: '2rem'
                            }}>
                                <span>Paket Layanan Kesehatan<RxSlash /></span>
                                {[
                                    product?.typeProductString,
                                    product?.ageGroupProductString,
                                    product?.name
                                ]
                                    .filter(Boolean)
                                    .map((item, index, array) => (
                                        <span key={index} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            {item}
                                            {index < array.length - 1 && <RxSlash size={15} />}
                                        </span>
                                    ))}
                            </p>

                            <Row style={{
                                borderTopLeftRadius: '2rem',
                                borderTopRightRadius: '2rem',
                                background: 'white'
                            }}>
                                <Col xs={12} md={9}>
                                    <Row>
                                        <img
                                            src={product.image ? product.image : 'default_480x320.png'}
                                            style={{ padding: '2rem', height: "50%", width: "40%", borderRadius: '20px' }}
                                            alt={product.name}
                                            className="mx-auto d-block"
                                        />

                                        <p className='h6'>Description</p>
                                        <div
                                            className="text-wrap overflow-hidden"
                                            style={{ fontSize: 13, textAlign: 'justify' }}
                                            dangerouslySetInnerHTML={{
                                                __html: product.description
                                            }}
                                        />
                                        <p className='h6'>Guidelines</p>
                                        <div
                                            className="text-wrap overflow-hidden"
                                            style={{ fontSize: 13, textAlign: 'justify' }}
                                            dangerouslySetInnerHTML={{
                                                __html: product.guidelines
                                            }}
                                        />
                                        <Row className='pb-3 ms-1 me-1'>
                                            <Row style={{ margin: 0, padding: 0 }}>
                                                {product?.categoriesProduct?.map((category, index) => (
                                                    <Col key={category.id} md={4} style={{ margin: 0, padding: 0 }}>
                                                        <Card
                                                            style={{
                                                                border: "none",
                                                                background: "none",
                                                                margin: "0 0 50px 0",
                                                                padding: 0,
                                                                margin: "10px 10px 10px 10px",
                                                            }}>
                                                            <Button
                                                                onClick={() => handleToggle(index)}
                                                                style={{
                                                                    fontSize: 14,
                                                                    background: "none",
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    border: "none",
                                                                    boxShadow: "none",
                                                                    width: "100%",
                                                                    padding: "10px 0",
                                                                    color: "black",
                                                                    borderBottom: "1px solid rgba(52, 132, 80, 0.2)", // Garis bawah
                                                                }}
                                                            >
                                                                <span style={{ fontSize: 13 }}>{category.name}</span>
                                                                {openIndex === index ? <FaMinus color="#8d070e" /> : <FaPlus color="#8d070e" />}
                                                            </Button>
                                                            <Collapse in={openIndex === index}>
                                                                <div>
                                                                    <Card.Body style={{ margin: 0, padding: "5px 0", background: "none", border: "none" }}>
                                                                        <p style={{ fontSize: 13, margin: 0, padding: 0, fontWeight: 15 }}>{category.categoriesProductDetail[0]?.name || "No details available"}</p>
                                                                        <div
                                                                            className="text-wrap overflow-hidden"
                                                                            style={{ fontSize: 11, textAlign: 'justify' }}
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: category.categoriesProductDetail[0]?.description || "No details available"
                                                                            }}
                                                                        />
                                                                    </Card.Body>
                                                                </div>
                                                            </Collapse>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Row>
                                        <p className='h6'>Terms and Conditions</p>
                                        <div
                                            className="text-wrap overflow-hidden"
                                            style={{ fontSize: 13, textAlign: 'justify' }}
                                            dangerouslySetInnerHTML={{
                                                __html: product.term_and_condition
                                            }}
                                        />

                                    </Row>
                                </Col>

                                <Col xs={12} md={3} style={{ paddingTop: '1.9rem' }}>
                                    <Card
                                        className="shadow-sm" style={{ border: "none" }}>
                                        <Card.Body>
                                            {/* Product Name */}
                                            <Card.Title>{product.name}</Card.Title>
                                            <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                                <Card.Text style={{
                                                    fontSize: 13,
                                                    maxHeight: "20px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 0, // Set max number of lines before truncation
                                                }}>Rp {product.starting_price}</Card.Text>
                                                <Form.Label column sm="6"
                                                    style={{
                                                        fontSize: 15,
                                                        maxHeight: "30px",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        display: "-webkit-box",
                                                        WebkitBoxOrient: "vertical",
                                                        WebkitLineClamp: 0, // Set max number of lines before truncation
                                                    }}>
                                                    Quantity
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control
                                                        type="number"
                                                        name="qty"
                                                        min="1"
                                                        value={quantity}
                                                        onChange={handleQuantityChange}
                                                        style={{ width: "100px", textAlign: 'center' }}
                                                    />
                                                </Col>
                                            </Form.Group>

                                            <Button
                                                onClick={() => handleOnAddToCart(product.id)} // Pass quantity to the handler
                                                style={{ width: "100%", background: '#8d070e' }}
                                            >
                                                <MdOutlineAddShoppingCart size={23} /> Add to Cart
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>

                    </DetailProductProvider>



                </Container>

            </Container>

            <Footer />
        </>
    );
};

export default DetailProductsPage;